module.exports = require("react-sharingbuttons");


//////////////////
// WEBPACK FOOTER
// external "react-sharingbuttons"
// module id = 259
// module chunks = 0